exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2.ui.header {\n  color: white;\n}\n\n\n.field label{\n  color: #FFFFFF;\n}\n\ntd.red {\ncolor: red;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/transport-interest/transport-interest.component.css
// module id = ../../../../../src/app/_components/transport-interest/transport-interest.component.css
// module chunks = main